import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Shows a Bootstrap modal automatically when the controller connects.
// Use this for modals loaded via turbo frames that should open immediately.
export default class extends Controller {
  connect() {
    // Clean up any stale backdrops from previous modals
    document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
      backdrop.remove();
    });

    this.modal = new Modal(this.element);
    this.modal.show();
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide();
      this.modal.dispose();
    }
  }
}
